export default "__VITE_ASSET__DzjZM2wM__ 600w";